import React from 'react';
import { observer } from 'mobx-react';
import { SellerEditTemplate } from 'themes/modules/seller/pages';
import { SellerEditViewStore } from 'modules/seller/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new SellerEditViewStore(rootStore), 'sellerEditViewStore')
@observer
class SellerEdit extends React.Component {
	render() {
		return <SellerEditTemplate {...this.props} />;
	}
}

export default SellerEdit;



// WEBPACK FOOTER //
// ./src/modules/seller/pages/SellerEdit.jsx